// extracted by mini-css-extract-plugin
export var actionButton = "_m9-0";
export var actionMenuContainer = "_m9-i";
export var bubble = "_m9-2";
export var bubbleActionMenu = "_m9-j";
export var bubbleContext = "_m9-6";
export var bubbleItems = "_m9-7";
export var customer = "_m9-3";
export var divider = "_m9-8";
export var fileList = "_m9-9";
export var hiddenComment = "_m9-o";
export var infoAbove = "_m9-a";
export var internal = "_m9-4";
export var lightActionButton = "_m9-1";
export var link = "_m9-b";
export var merchant = "_m9-5";
export var message = "_m9-c";
export var profilePicture = "_m9-e";
export var quillToolbarContainer = "_m9-f";
export var senderDate = "_m9-g";
export var senderDateCustomer = "_m9-h";
export var senderName = "_m9-d";
export var time = "_m9-k";
export var uploadedImage = "_m9-l";
export var username = "_m9-m";
export var xsmall = "_m9-n";